import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { timeout } from 'rxjs/operators';
import { SamlUrl } from "../api-urls";
import { ToastrService } from 'ngx-toastr';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
    })
};

@Injectable()

export class HttpRequestService {

    public endpoint: string = '';
    public logoutUrl: string = '';
    public toasterOptions: any = { animate: 'fade', showCloseButton: true, position: 'top-center', dismiss: 'click', maxShown: 1, newestOnTop: true };
    constructor(public http: HttpClient, public toaster: ToastrService) {
    }

    public setLogoutURL(logouturl: string) {
        this.logoutUrl = logouturl;
    }

    public getLogoutURL() {
        return this.logoutUrl;
    }

    logOut() {
        localStorage.removeItem('isLoggedin');
        window.location.assign(this.getLogoutURL());
    }

    public setEndPoint(value: any) {
        this.endpoint = value;
    }

    public getEndPoint() {
        return this.endpoint;
    }
    headers: any;
    setHeaders(withCredentials: any) {
        this.headers = new HttpHeaders({
            'Content-Type': 'application/json'
        })
    }

    getHeaders() {
        return new HttpHeaders({
            'Content-Type': 'application/json'
        })
    }

    showLoader() {
        let element: any = document.getElementById('loader');
        if (element != null) {
            element.style.display = 'block';
        }

    }

    hideLoader() {
        let element: any = document.getElementById('loader');
        if (element != null) {
            element.style.display = 'none';
        }
    }

    public getRequest(request: any = {}) {
        if (this.isOffline()) {
            return;
        }
        if (request.hideLoader) {
            this.hideLoader();
        }
        this.http.get(request.action, {
            headers:
                this.getHeaders(), withCredentials: true
        }).pipe(
            timeout(30000)
        ).subscribe(
            (data: any) => {
                data = data || {};
                if (data.hasOwnProperty(status)) {
                    this.errorToast(data.message);
                } else {
                    request.success(data);
                }
            }
        )
    }

    public postRequest(request: any = {}) {
        if (this.isOffline()) {
            return;
        }
        this.http.post(request.action, request.params, {
            headers:
                this.getHeaders(), withCredentials: true
        }).pipe(
            timeout(30000)
        ).subscribe(
            (data: any) => {
                data = data || {};
                if (request.success) {
                    request.success(data);
                }
                if (!request.noMessage) {
                    this.successToast(request.message || 'Request Processed Successfully');
                }
            },
            (error: HttpErrorResponse) => {
                if (request.error) {
                    request.error(error);
                }
            }
        )
    }

    public errorToast(error: string) {
        this.toaster.error(error, 'Error', this.toasterOptions);
    }

    public warningToast(message: string) {
        this.toaster.warning(message, 'Alert!', this.toasterOptions);
    }

    public infoToast(message: any) {
        let toasterOptions = JSON.parse(JSON.stringify(this.toasterOptions));
        toasterOptions['timeout'] = 10;
        delete toasterOptions.dismiss;
        this.toaster.info(message, 'Info', toasterOptions);
    }

    public successToast(message: any) {
        let toasterOptions = JSON.parse(JSON.stringify(this.toasterOptions));
        toasterOptions['timeout'] = 5;
        delete toasterOptions.dismiss;
        this.toaster.success(message, 'Success', toasterOptions);
    }

    public deleteRequest(request: any) {
        if (this.isOffline()) {
            return;
        }
        this.http.delete(request.action, {
            headers:
                this.getHeaders(), withCredentials: true
        }).pipe(
            timeout(30000)
        ).subscribe(
            (data: any) => {
                data = data || {};
                if (data.hasOwnProperty(status)) {
                    this.errorToast(data.message);
                } else {
                    if (request.success) {
                        request.success();
                    }
                    this.successToast(request.message || 'Request Processed Successfully');
                }
            }
        )
    }

    public putRequest(request: any) {
        if (this.isOffline()) {
            return;
        }
        let params: any = request.params || {};
        this.http.put(request.action, params, {
            headers:
                this.getHeaders(), withCredentials: true
        }).pipe(
            timeout(30000)
        ).subscribe(
            (data: any) => {
                data = data || {};
                if (data.hasOwnProperty(status)) {
                    this.errorToast(data.message);
                    if (request.error) {
                        request.error();
                    }
                } else {
                    if (request.success) {
                        request.success(data);
                    }
                    this.successToast(request.message || 'Request Processed Successfully');
                }
            },
            (error: any) => {
                if (request.error) {
                    request.error();
                }
            }
        )
    }
    SamlUrls: any = SamlUrl;
    getLoggedIn() {
        let location: any = window.location.href;
        this.http.get('loggedIn', { withCredentials: true })
            .subscribe((data: any) => {
                data = data || {};
                if (data.isLoggedIn == false) {
                    let key: string = this.getInstanceType();
                    setTimeout(() => {
                        window.location.assign(this.SamlUrls[key + '_login']);
                    }, 100);
                }
            }
            );
    }

    getInstanceType() {
        let pageUrl: string = window.location.origin;
        let instance: string;
        if (pageUrl.includes('saasdev')) {
            instance = 'dev';
        } else if (pageUrl.includes('saasqa')) {
            instance = 'qa';
        } else if (pageUrl.includes('saasstaging')) {
            instance = 'staging';
        } else if (pageUrl.includes('art-saas-devicemgt-ui:8089')) {
            instance = 'local_docker';
        } else if (pageUrl.includes('local')) {
            instance = 'local';
        } else {
            instance = 'prod';
        }
        return instance
    }

    isOffline() {
        if (navigator.onLine) {
            return false;
        }
        this.errorToast('Please check your internet connection');
        return true;
    }
}